module.exports = __webpack_public_path__ + "static/media/faza2_AL.c0d02e21.svg";